import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { defineMessage, useIntl } from 'react-intl';

import CarrierLogoColumn from '../../components/columns/carrier-logo-column';
import GetCarrierDisplayName from '../../components/data-driven-logo/get-carrier-display-name';
import Global from '../../store/global-selectors';

const pendingMessage = defineMessage({
  defaultMessage: 'Pending',
  description: 'label for providers that are pending approval',
  id: 'O7OSAx',
});

export const CarrierColumnContainer = ({ carrierId, providerId }) => {
  const intl = useIntl();
  const sellerLabelProviders = useSelector(Global.selectSellerLabelProviders);
  const dataDrivenLogoProps = useMemo(() => {
    const intProviderId = providerId ? Number.parseInt(providerId, 10) : undefined;
    const intCarrierId = carrierId ? Number.parseInt(carrierId, 10) : undefined;
    return {
      providerId: intProviderId,
      carrierId: intCarrierId,
    };
  }, [providerId, carrierId]);

  const label = useMemo(() => {
    const { isPendingApprovalToCreateLabel = false } = sellerLabelProviders.find((slp) => slp.labelProviderId === providerId) ?? {};
    const carrierDisplayMessage = GetCarrierDisplayName(carrierId);
    const carrierDisplayLabel = intl.formatMessage(carrierDisplayMessage, carrierDisplayMessage.values);
    const pendingLabel = intl.formatMessage(pendingMessage);
    return `${carrierDisplayLabel}${isPendingApprovalToCreateLabel ? ` (${pendingLabel})` : ''}`;
  }, [carrierId, intl, providerId, sellerLabelProviders]);

  if (!carrierId) {
    return <CarrierLogoColumn isEmpty />;
  }

  return <CarrierLogoColumn dataDrivenLogoProps={dataDrivenLogoProps} message={label} />;
};

CarrierColumnContainer.propTypes = {
  carrierId: PropTypes.string,
  providerId: PropTypes.string,
};
